var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.46965 2.46967C6.76254 2.17678 7.23741 2.17678 7.53031 2.46967L12.3033 7.24264C12.5962 7.53553 12.5962 8.01041 12.3033 8.3033C12.0104 8.59619 11.5355 8.59619 11.2426 8.3033L7.74998 4.81066L7.74998 21C7.74998 21.4142 7.41419 21.75 6.99998 21.75C6.58576 21.75 6.24998 21.4142 6.24998 21L6.24998 4.81066L2.75734 8.3033C2.46444 8.59619 1.98957 8.59619 1.69668 8.3033C1.40378 8.01041 1.40378 7.53553 1.69668 7.24264L6.46965 2.46967Z",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5304 21.5303C17.2375 21.8232 16.7626 21.8232 16.4697 21.5303L11.6967 16.7574C11.4038 16.4645 11.4038 15.9896 11.6967 15.6967C11.9896 15.4038 12.4645 15.4038 12.7574 15.6967L16.25 19.1893L16.25 3C16.25 2.58578 16.5858 2.25 17 2.25C17.4142 2.25 17.75 2.58578 17.75 3L17.75 19.1893L21.2427 15.6967C21.5356 15.4038 22.0104 15.4038 22.3033 15.6967C22.5962 15.9896 22.5962 16.4645 22.3033 16.7574L17.5304 21.5303Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortBlack);
export default __webpack_public_path__ + "static/media/SortBlack.aeac3575b3cde60072a89895b5a8ae0d.svg";
export { ForwardRef as ReactComponent };